export default {
  presentation: 'Presentación',
  teacher: 'Docente',
  student: 'Estudiante',
  reviews: 'Sin valoraciones | {n} valoración | {n} valoraciones',
  bio: 'Bio',
  webinar: 'Webinar',
  webinarDesc: 'Este recurso incluye una videoconferencia directamente con el autor. ¡Kimple te conecta!',
  benefits: 'Beneficios del recurso',
  explore: 'Explorar el recurso',
  type: 'Tipo de Recurso',
  age: 'Edad',
  duration: 'Duración',
  session: '{n} Clase | {n} Clases',
  skills: 'Habilidades',
  moreTopics: '+{n} temática más | +{n} temáticas más',
  topicsAssociated: 'Temáticas y sub-temáticas asociadas al recurso',
  skillsNames: {
    flexibility: 'Flexibilidad',
    initiative: 'Iniciativa',
    creativity: 'Creatividad',
    responsibility: 'Responsabilidad',
    problemResolution: 'Resolución de problemas',
    leadership: 'Liderazgo',
    communication: 'Comunicación',
    resilience: 'Resiliencia',
    criticalThinking: 'Pensamiento crítico',
    teamwork: 'Trabajo en equipo',
    analysis: 'Análisis',
    perseverance: 'Perseverancia'
  },
  subjects: {
    math: 'Matemática',
    language: 'Lengua',
    art: 'Arte',
    arts: 'Arte',
    languages: 'Idiomas',
    transversal: 'Transversal',
    socialSciences: 'Ciencias sociales',
    naturalSciences: 'Ciencias naturales',
    technology: 'Tecnología'
  },
  mode: 'Implementación',
  online: 'Online',
  offline: 'Offline',
  materials: 'Materiales',
  interest: 'También te puede interesar',
  rateResource: 'Valorar este recurso',
  state1: {
    title: '¡Gracias por usar este recurso!',
    subtitle: '¿Qué tan útil te pareció?'
  },
  state2: {
    title: 'Cuéntanos más,',
    subtitleLike: '¿qué te gustó?',
    subtitleImprove: '¿qué optimizarías del recurso evaluado?'
  },
  leaveMessage: '¿Quieres dejarnos un mensaje?',
  commentPlaceholder: 'Escribe aquí tu mensaje...',
  thanks: '¡Gracias!',
  rate: 'Calificar',
  innovation: 'Innovación',
  applicability: 'Aplicabilidad en el aula',
  structure: 'Estructura',
  teachingGuide: 'Guía docente',
  author: 'Autor',
  need: 'Vas a necesitar:',
  electronicMaterial: 'Dispositivos',
  classMaterial: 'Materiales',
  downloadMaterial: 'Contenido descargable',
  areas: 'Áreas Cruzadas',
  program: 'Programa',
  resourceTypes: {
    Workshop: 'Taller',
    Project: 'Proyecto',
    Case: 'Caso',
    DidacticSequence: 'Secuencia Didáctica',
    Exercise: 'Ejercicio'
  },
  ods: 'Este recurso promueve los siguientes ODS:',
  redirection: 'El recurso no se encuentra en el idioma seleccionado, pero lo puedes ver en ',
  and: 'y ',
  implementationType: {
    online: 'Online',
    offline: 'Offline',
    mix: 'Online/Offline'
  }
}

export const en = {
  presentation: 'Presentation',
  teacher: 'Teacher',
  student: 'Student',
  reviews: 'No reviews | {n} review | {n} reviews',
  bio: 'Bio',
  webinar: 'Webinar',
  webinarDesc: 'This resource includes a video call with the author. Kimple connects you!',
  benefits: 'Resource benefits',
  explore: 'Explore resource',
  type: 'Type of Resource',
  age: 'Age',
  duration: 'Duration',
  session: '{n} Lesson | {n} Lessons',
  skills: 'Skills',
  moreTopics: '+{n} more topic | +{n} more topics',
  topicsAssociated: 'Topis and sub topics associated',
  skillsNames: {
    flexibility: 'Flexibility',
    initiative: 'Initiative',
    creativity: 'Creativity',
    responsibility: 'Responsibility',
    problemResolution: 'Problem solving',
    leadership: 'Leadership',
    communication: 'Communication',
    resilience: 'Resilience',
    criticalThinking: 'Critical thinking',
    teamwork: 'Team work',
    analysis: 'Analysis',
    perseverance: 'Perseverance'
  },
  subjects: {
    math: 'Math',
    language: 'Language',
    art: 'Art',
    arts: 'Art',
    languages: 'Languages',
    transversal: 'Transversal',
    socialSciences: 'Social Sciences',
    naturalSciences: 'Natural Sciences',
    technology: 'Technology'
  },
  mode: 'Implementation',
  online: 'Online',
  offline: 'Offline',
  materials: 'Materials',
  interest: 'You may also find interesting',
  rateResource: 'Rate resource',
  state1: {
    title: 'Thank you for using this resource!',
    subtitle: 'How useful was it?'
  },
  state2: {
    title: 'Tell us more about it,',
    subtitleLike: 'what did you like?',
    subtitleImprove: 'what would you improve?'
  },
  leaveMessage: 'Do you want to leave us a message?',
  commentPlaceholder: 'Write here your message...',
  thanks: 'Thank you!',
  rate: 'Rate',
  innovation: 'Innovation',
  applicability: 'Classroom applicability',
  structure: 'Structure',
  teachingGuide: 'Teaching guide',
  author: 'Author',
  need: 'You\'ll need',
  electronicMaterial: 'Devices',
  classMaterial: 'Materials',
  downloadMaterial: 'Downloadable content',
  areas: 'Cross-sectional areas',
  program: 'Program',
  resourceTypes: {
    Workshop: 'Workshop',
    Project: 'Project',
    Case: 'Case',
    DidacticSequence: 'Didactic sequence',
    Exercise: 'Exercise'
  },
  ods: 'This resource promotes the following SDGs:',
  redirection: 'The resource is not available in the selected language, but you can see it in ',
  and: 'and ',
  implementationType: {
    online: 'Online',
    offline: 'Offline',
    mix: 'Online/Offline'
  }
}

export const ca = {
  presentation: 'Presentació',
  teacher: 'Docent',
  student: 'Estudiant',
  reviews: 'Sense valoracions | {n} valoració | {n} valoracions',
  bio: 'Bio',
  webinar: 'Seminari web',
  webinarDesc: 'Aquest recurs inclou una videoconferència directa amb l\'autor. Kimple et connecta!',
  benefits: 'Beneficis del recurs',
  explore: 'Explora el recurs',
  type: 'Tipus de Recurs',
  age: 'Edat',
  duration: 'Durada',
  session: '{n} Classe | {n} Classes',
  skills: 'Habilitats',
  moreTopics: '+{n} temàtiques més | +{n} temàtiques més',
  topicsAssociated: 'Temàtiques i sub-temàtiques associades al recurs',
  skillsNames: {
    flexibility: 'Flexibilitat',
    initiative: 'Iniciativa',
    creativity: 'Creativitat',
    responsibility: 'Responsabilitat',
    problemResolution: 'Resolució de problemes',
    leadership: 'Lideratge',
    communication: 'Comunicació',
    resilience: 'Resiliència',
    criticalThinking: 'Pensament crític',
    teamwork: 'Treball en equip',
    analysis: 'Anàlisi',
    perseverance: 'Perseverança'
  },
  subjects: {
    math: 'Matemàtica',
    language: 'Llengua',
    art: 'Art',
    arts: 'Art',
    languages: 'Idiomes',
    transversal: 'Transversal',
    socialSciences: 'Ciències socials',
    naturalSciences: 'Ciències naturals',
    technology: 'Tecnologia'
  },
  mode: 'Implementació',
  online: 'Online',
  offline: 'Offline',
  materials: 'Materials',
  interest: 'Qui ha vist això també ha vist',
  rateResource: 'Valorar aquest recurs',
  state1: {
    title: 'Gràcies per fer servir aquest recurs!',
    subtitle: 'Com d\'útil t\'ha semblat?'
  },
  state2: {
    title: 'Dona\'ns més detalls,',
    subtitleLike: 'què és el que t\'ha agradat?',
    subtitleImprove: 'què optimitzaries del recurs que has avaluat?'
  },
  leaveMessage: 'Vols deixar-nos un missatge?',
  commentPlaceholder: 'Escriu el teu missatge aquí... ',
  thanks: 'Gràcies!',
  rate: 'Puntua\'l',
  innovation: 'Innovació',
  applicability: 'Aplicabilitat a la classe',
  structure: 'Estructura',
  teachingGuide: 'Guia docent',
  author: 'Autor',
  need: 'Necessitaràs:',
  electronicMaterial: 'Dispositius',
  classMaterial: 'Materials',
  downloadMaterial: 'Contingut descarregable',
  areas: 'Àrees Creuades',
  program: 'Programa',
  resourceTypes: {
    Workshop: 'Taller',
    Project: 'Projecte',
    Case: 'Cas',
    DidacticSequence: 'Seqüència Didàctica',
    Exercise: 'Exercici'
  },
  ods: 'Aquest recurs fomenta els següents ODS:',
  redirection: 'El recurs no es troba en l\'idioma seleccionat, però el pots veure en ',
  and: 'y ',
  implementationType: {
    online: 'Online',
    offline: 'Offline',
    mix: 'Online/Offline'
  }
}
